import React, {FC} from "react";
import { ILogin } from "../../../../utils/types";

interface TermProp {
  login: ILogin;
  handleChange(field: string, value: any): void;
  urlTerm: string;
  styleForLink: object;
  textReadAndAgree: string;
  textTerm: string;
}

const LoginTerm: FC<TermProp> = ({
  login,
  handleChange,
  urlTerm,
  styleForLink,
  textReadAndAgree,
  textTerm,
}) => {
  return (
    <>
      <label
        htmlFor="terms"
        style={{ color: "white", paddingRight: "5px" }}
      >
        {textReadAndAgree}
      </label>
      <a href={urlTerm} rel="noreferrer" target="_blank" style={styleForLink}>
        {textTerm}
      </a>
    </>
  );
};

export default LoginTerm;
